export default "__VITE_ASSET__CfjA7nP$__"